/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { ThemeProvider } from "@mui/material/styles";
import { theme, customStyles2 } from "../../util/TableStyles";
import { noDataComponent } from "../../util/DataObject"

const InfoAbbUser = (props) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    init();
  }, [props.content]);

  const init = () => {
    setData(JSON.parse(JSON.stringify(props.content.data.company)));
  };

  const columns = [
    { selector: (row) => row.name, name: "Empresa", width:"68%", wrap: true },
    { selector: (row) => row.rol && props.roles?.map((rol, i) => {
      if(rol?.uuid === row.rol[0].uuid ){
        return <p key={i}>{rol?.name}</p>;
      }}), 
      name: "Rol", width:"32%" },    
  ];

  return (
    <div style={{ width: "60%", margin: "auto", marginLeft: "47px", marginBottom: "20px"}}>
      <ThemeProvider theme={theme}>
        <DataTable
          columns={columns}
          data={data}       
          customStyles={customStyles2}  
          noDataComponent={noDataComponent}
          dense 
        />
      </ThemeProvider>
    </div>
  );
};

export default InfoAbbUser;
